import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
})
export class CookiePolicyComponent implements OnInit {
  constructor(private titleService: Title, private translate: TranslateService) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.translate.instant('Cookie Policy') + ' ' + '| The Seychelles Islands');
  }
}
